/* =====================================================================
   AIRFORCE · ad landing pages: shared helpers (Oct 30, 2026)
   In the theme this loads (deferred) from inside each landing section, which is BEFORE af-core,
   so nothing here touches AF until a page script calls it.
   window.AF_LANDING = the section's settings (tiers, video link, bundle amounts), written by the section.
   ===================================================================== */
window.AFLP = (function () {
  "use strict";
  var api = {};
  var A = function () { return window.AF; }, D = function () { return window.AF_DATA; };
  api.cfg = function () { return window.AF_LANDING || {}; };

  /* one page, one offer: no menu, announcement bar, search or account. The cart and My Garage stay. Slim footer.
     The logo still links to the homepage, for riders who want more info and products (Cole, Oct 30). */
  api.chrome = function (cur, subject) {
    var AF = A(), d = D(), esc = AF.esc;
    document.body.classList.add("af-lp-body");
    AF.renderChrome(cur);
    var f = document.querySelector(".af-footer");
    if (f) f.outerHTML = '<footer class="af-lp-foot"><div class="af-wrap"><span>© 2026 ' + esc(d.brand.name) + " · " + esc(d.brand.address) + "</span><span>Email " + AF.emailLink(subject) + " · Prices in CAD</span></div></footer>";
  };

  /* video under the headline (YouTube or Instagram link). No link = the slot disappears. */
  api.video = function (el, url, title) {
    if (!el) return false;
    var AF = A(), src = AF.embedSrc(url);
    if (!src) { el.remove(); return false; }
    el.innerHTML = '<div class="af-lp-video__frame' + (/instagram/.test(src) ? " is-tall" : "") + '"><iframe src="' + src + '" title="' + AF.esc(title || "Video") + '" loading="lazy" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe></div>';
    return true;
  };

  /* proof right under the call to action */
  api.under = function (el, items) { if (el) el.innerHTML = items.filter(Boolean).map(function (t) { return "<span>" + A().esc(t) + "</span>"; }).join(""); };

  /* reviews, wording never changed */
  api.reviews = function (el, keep) {
    var list = D().reviews.filter(keep || function () { return true; });
    if (el) el.innerHTML = list.map(A().reviewCard).join("");
    return list;
  };

  /* FAQ: questions picked by their exact wording from AF_DATA.faqs, or { q, a } written for the page */
  api.faq = function (el, picks) {
    var AF = A(), fs = picks.map(function (x) { return typeof x === "string" ? D().faqs.filter(function (f) { return f.q === x; })[0] : x; }).filter(Boolean);
    if (el) el.innerHTML = fs.map(function (f, i) { return "<details" + (i === 0 ? " open" : "") + "><summary>" + AF.esc(f.q) + "</summary><p>" + AF.txt(f.a) + "</p></details>"; }).join("");
  };

  /* phones: a slim call-to-action bar once the hero is off screen, hidden while the offer is on screen */
  api.bar = function (bar, hero, offers) {
    offers = [].concat(offers).filter(Boolean);
    if (!bar || !hero || !offers.length || !("IntersectionObserver" in window)) return;
    var heroOn = true, on = offers.map(function () { return false; });
    var paint = function () { bar.classList.toggle("is-on", !heroOn && !on.some(Boolean)); };
    new IntersectionObserver(function (es) { heroOn = es[0].isIntersecting; paint(); }).observe(hero);
    offers.forEach(function (o, i) { new IntersectionObserver(function (es) { on[i] = es[0].isIntersecting; paint(); }, { rootMargin: "0px 0px -30% 0px" }).observe(o); });
  };

  /* cart subtotal before order discounts (Shopify: items_subtotal_price; preview: the lines) */
  api.subtotal = function () {
    var C = A().cart, raw = C.raw;
    return raw ? (raw.items_subtotal_price != null ? raw.items_subtotal_price : raw.original_total_price) / 100
      : C.items.reduce(function (s, x) { return s + (x.price || 0) * x.qty; }, 0);
  };
  /* a note at the top of the cart drawer on this page, e.g. how far to the next discount tier */
  api.cartNote = function (fn) {
    var AF = A(), C = AF.cart, r0 = C.render;
    C.render = function () {
      r0.apply(this, arguments);
      var body = document.getElementById("af-cart-body"); if (!body || !this.items.length) return;
      var html = fn(api.subtotal(), this.items); if (!html) return;
      var el = document.createElement("div"); el.className = "af-ship af-lp-cartnote"; el.innerHTML = html;
      body.insertBefore(el, body.firstChild);
    };
    C.render();
  };

  /* spend-more-save-more tiers (power packages page). They only show the offer: Shopify takes it off at checkout. */
  api.tiers = function () {
    var L = api.cfg();
    var T = (L.tiers || [{ min: 3000, pct: 5 }, { min: 5000, pct: 7 }, { min: 8000, pct: 10 }])
      .filter(function (t) { return t && t.min > 0 && t.pct > 0; }).sort(function (a, b) { return a.min - b.min; });
    var on = L.showTiers !== false && T.length > 0;
    return {
      list: on ? T : [], on: on, max: on ? T[T.length - 1].pct : 0,
      at: function (amt) { var t = null; if (on) T.forEach(function (x) { if (amt >= x.min) t = x; }); return t; },
      next: function (amt) { return on ? T.filter(function (x) { return amt < x.min; })[0] || null : null; }
    };
  };

  return api;
})();
